import {
  AppointmentsService,
  ListAppointmentsRequest,
} from '@weave/schema-gen-ts/dist/schemas/appointments/v3/service.pb';
import { MockPersons } from '@frontend/api-person';
import { FeatureMockRouter } from '@frontend/demo-interceptors';
import { MockAPIRouter } from '@frontend/fetch';
import { computeForcedStartForThisWeek, getAppointmentIds, makeAppointment } from '../appointments';
import { BaseMockRouterContext } from './types';

export interface CallIntelTssMockRouterContext extends BaseMockRouterContext {
  mockPersonsInstance: MockPersons;
}

export const CallIntelTssMockRouter: FeatureMockRouter<CallIntelTssMockRouterContext> = {
  addMockRouterEndpoints: (router) => {
    router.schemaEndpoint(AppointmentsService.ListAppointments, async (request, _, next) => {
      const requestBody: ListAppointmentsRequest = await request.clone().json();
      const { filters = [] } = requestBody;

      const appointmentIds = getAppointmentIds(filters);

      if (!!appointmentIds.length) {
        const forcedStart = computeForcedStartForThisWeek();
        return MockAPIRouter.json({
          appointments: appointmentIds.map((id) =>
            makeAppointment({ appointmentId: id, overrides: { appointmentAt: forcedStart } })
          ),
        });
      }
      next();
      return null;
    });
  },
};
